/* unplugin-vue-components disabled */import script from "./Breadcrumb.vue?vue&type=script&setup=true&lang=ts"
export * from "./Breadcrumb.vue?vue&type=script&setup=true&lang=ts"

import "./Breadcrumb.vue?vue&type=style&index=0&id=e6623386&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6623386"]])

export default __exports__